import en from './messages/en.json'
import ar from './messages/ar.json'
import fr from './messages/fr.json'
export const messages = {
  en,
  ar,
  fr,
}